// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"846ef4b8","168":"6be5f717","186":"2225b0e2","482":"73385c9a","863":"42f97ca6"}[chunkId] + ".chunk.js";
};